import { render, staticRenderFns } from "./GestioneRegole.vue?vue&type=template&id=e6327966&"
import script from "./GestioneRegole.vue?vue&type=script&lang=js&"
export * from "./GestioneRegole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports